import React from 'react';
import {Input} from "@/components/ui/input";

interface SearchInputProps {
    value: string;
    onChange: (value: string) => void;
}

const SearchInput: React.FC<SearchInputProps> = ({value, onChange}) => (
    <Input
        placeholder="جستجوی برند"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="mb-2 rounded-xl h-[48px]"
    />
);

export default SearchInput;

